import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompanyUsersCount = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  return await axios.get(
    `/api/companies/${companyID}/users/count?${queryString}`
  );
};

const defaultQueryParams = {
  includeInactive: false,
  status: undefined,
  queryOptions: {},
};

export const useCompanyUsersCount = (companyID, queryParams = {}) => {
  const { includeInactive, status, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    includeinactive: includeInactive,
    ...(status ? { status } : {}),
  };

  return useQuery(
    `company-${companyID}-users-count-status-${status || includeInactive}`,
    () => getCompanyUsersCount(companyID, queryStringParams),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...queryOptions,
    }
  );
}